var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.242 3.59497C5.089 3.75197 5 3.99797 5 4.31697V15.678C5 15.997 5.089 16.243 5.242 16.401L5.28 16.435L11.719 10.072V9.92297L5.281 3.56097L5.242 3.59497Z",
    fill: "#BABBC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.862 12.193L11.72 10.072V9.923L13.866 7.802L13.913 7.832L16.455 9.26C17.182 9.668 17.182 10.335 16.455 10.743L13.913 12.171L13.862 12.193Z",
    fill: "#BABBC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9129 12.168L11.7199 10L5.24194 16.401C5.48394 16.652 5.87494 16.682 6.32194 16.431L13.9129 12.168Z",
    fill: "#898B94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9129 7.82799L6.32194 3.56499C5.87594 3.31799 5.47994 3.34799 5.24194 3.59899L11.7199 9.99999L13.9129 7.82799Z",
    fill: "#A2A3AA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.9274586a8d49af6771e9e9e2ef163669.svg";
export { ForwardRef as ReactComponent };